import { withPlugins, domEvents } from '@spon/plugins';
import Cookies from 'js-cookie';

function CookieConsent({ node, plugins: { addEvents } }) {
	// instantly lock if we're here..
	document.body.style.position = 'fixed';
	// document.body.style.top = `${windowTop * -1}px`;
	document.body.style.overflow = 'hidden';
	document.body.style.width = '100vw';

	function closePopup() {
		// Dont prevent; it might be a link but we still want to set cookie
		Cookies.set('seen-popup', true, { expires: 30 });

		node.style.opacity = 0;
		setTimeout(() => {
			node.remove();
		}, 300); // same as css transition

		// then release if closing
		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.overflow = '';
		document.body.style.width = '';
	}

	function onClick({ target }) {
		// Only close if clicking on...
		if (
			target.id === node.id ||
			target.tagName === 'BUTTON' ||
			target.tagName === 'A'
		) {
			closePopup();
		}
	}

	function onKeyDown(event) {
		const { keyCode } = event;
		if (keyCode === 27) closePopup();
	}

	addEvents({
		click: onClick,
	});

	addEvents(document.body, {
		keydown: onKeyDown,
	});
}

export default withPlugins(domEvents)(CookieConsent);
